module.exports = __webpack_public_path__ + "img/warehouse.6e163399.png";